import React, { useEffect } from "react";
import CommonHeader from "../../../Components/Common/CommonHeader/CommonHeader";
import TableWrapper from "../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import { useSelector, useDispatch } from "react-redux";
import { getFilteredDataWithTabs } from "../../../Utils/CommonService";
import useQualificationColumns from "./Hooks/useQualificationColumns";
import QualificationFilter from "./QualificationFilter";
import NewQualificationModal from "./Modal/NewQualificationModal";
import { resetFormState } from "../../../slices/common/reducer";
import {
    setQualificationData,
    setQualificationSorting,
    setQualificationFilterForm,
} from "../../../slices/qualification/qualificationsSlice";

const QualificationList = () => {
    const dispatch = useDispatch();
    const modalShow = useSelector((state) => state.common.modalShow);
    const editShow = useSelector((state) => state.common.editShow);
    const qualificationData = useSelector(
        (state) => state.qualification.qualificationData
    );
    const totalRows = useSelector(
        (state) => state.common.pagination.totalCount
    );
    const apiTabData = useSelector(
        (state) => state.common.pagination.tabs
    );
    const filterApi = useSelector(
        (state) => state.qualification.filter.filterApi
    );
    const filterForm = useSelector(
        (state) => state.qualification.filter.form
    );
    const sortColumn = useSelector(
        (state) => state.qualification.sorting.column
    );
    const sortOrder = useSelector(
        (state) => state.qualification.sorting.order
    );

    const enterpriseid = localStorage.getItem("enterpriseid");
    const userid = localStorage.getItem("userId");

    const { qualificationColumns } = useQualificationColumns();

    useEffect(() => {
        dispatch(resetFormState());
        dispatch(setQualificationFilterForm({ type: "reset" }));
    }, []);

    return (
        <div>
            <CommonHeader
                newButton={true}
                checkAccessCreate={true}
                buttonTitle={"New"}
                filterComponent={<QualificationFilter />}
                dash={true}
                filterIcon={false}
                offcanvasopen={() => { }}
            />
            <div>
                <TableWrapper
                    columns={qualificationColumns}
                    data={qualificationData}
                    apiTabData={apiTabData}
                    paginatedApi
                    filterApi={filterApi}
                    filterApiEntity={"QUAL"}
                    filterApiListEntity={"QUAL"}
                    filterApiFunction={setQualificationData}
                    filterApiService={getFilteredDataWithTabs}
                    filterForm={filterForm}
                    totalRows={totalRows}
                    status={"ALL"}
                    statusColumn={"status"}
                    hideTabsWrapper={true}
                    serverSort
                    serverSortColumn={sortColumn}
                    serverSortOrder={sortOrder}
                    serverSortState={setQualificationSorting}
                    enterpriseId={enterpriseid}
                    userId={userid}
                />
            </div>
            {(modalShow || editShow) && <NewQualificationModal />}
        </div>
    );
};

export default QualificationList;